/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { SetStateAction, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import {KTSVG} from '../../../../_metronic/helpers'
import { FilterSearchModel } from '../../../types'
import FilterButton from './FilterButton'
import ListTable from './ListTable'

type Props = {
  className: string,
  isAdmin: boolean | undefined,
  isLoading: boolean,
  influencers: any[] | undefined,
  model: FilterSearchModel | undefined,
  setModel: React.Dispatch<SetStateAction<FilterSearchModel | undefined>>,
  handleSMSSent: (requestId: string) => void
}

const ListTableWidget: React.FC<Props> = ({className, isAdmin, isLoading, influencers, model, setModel, handleSMSSent}) => {

  const [filteredList, setFilteredList] = useState<any[] | undefined>()
  const [searchText, setSearchedText] = useState<string | null>()

  useEffect(() => {
    if(searchText) {
      setFilteredList(influencers?.filter((influencer) => {
        if(influencer.Name?.toLowerCase().includes(searchText.toLowerCase())) {
          return influencer
        } else if(influencer.Surname?.toLowerCase().includes(searchText.toLowerCase())) {
          return influencer
        } else if(influencer.MobilePhoneNumber?.toLowerCase().includes(searchText.toLowerCase())) {
          return influencer
        }
      }))
    } else {
      setFilteredList(influencers)
    }
  }, [searchText, influencers])


  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        {!isAdmin ? <div className='card-toolbar'>
          <Link to='/sign-up' className='btn btn-sm btn-light-primary'>
            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
            Yeni Kayıt
          </Link>
        </div> : <div></div>}
        <div className='d-flex w-80 position-relative align-items-center'>
          <input
            id='searchInput'
            type='text'
            className='form-control form-control-solid px-15 h-30px h-md-40px w-90 '
            name='search'
            placeholder='Arama'
            onChange={(e) => setSearchedText(e.target.value)}
          />
          <KTSVG
            path='/media/icons/duotune/general/gen021.svg'
            className='svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute  ms-5 translate-middle-y top-25 mt-4'
          />

          <div className='d-flex align-items-stretch ms-1 ms-lg-3'>
            <FilterButton isAdmin={isAdmin} model={model} setModel={setModel}/>
          </div>
        </div>
        
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <ListTable isAdmin={isAdmin} influencers={filteredList} isLoading={isLoading} handleSMSSent={handleSMSSent}/>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
  )
}

export {ListTableWidget}
